/**
 * Grid PDP is a type of PDP which allows purchase in a grid-format (similar to a product compare)
 * with extended data about each variant and multiple data points.
 * Note that in production mode the .min version of this file is loaded
 * Launch Date: 2020-07-22
 * Stephen Adamson <sadamson@metacommerce.com>
 */



/**
 * Number of attributes (rows) above which we add a second add to cart button.
 * Currently unreachably high because people were unhappy with how it looked
 * @type {number}
 */
const DOUBLE_ATC_AT = 27;

const titleCase = function(str) {
    return str.toLowerCase().split('-').map(function(word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
};

/**
 * Collects data from the dom and returns as an object.
 * See the file snippets\product-form-grid.liquid for the source of this data
 * @returns Object
 */
const parseItemData = function() {

    let itemdata = {};
    for (let itemrow of $('#grid-product-container').children('div.grid-product-data-row')) {
        let data = $(itemrow).data('row');
        if (typeof data['variant'] != 'undefined') { // This is bad JSON, possibly quotes in option names
            itemdata[data['variant']] = data;
        }
    }
    itemdata = removeEmptyRows(itemdata);
    return itemdata;
};

/**
 * Removes completely empty rows from the options array of all the skus
 */
const removeEmptyRows = function(itemdata) {
    let empty_counts = {}
    // Find and count all of the empty fields
    for (let sku in itemdata) {
        let sku_options = itemdata[sku]['options'];
        for (let fieldname in sku_options) {
            if (sku_options[fieldname].toString() == '') {
                if (empty_counts[fieldname]) {
                    empty_counts[fieldname] += 1;
                } else {
                    empty_counts[fieldname] = 1;
                }
            }
        }
    }
    let num_skus = Object.keys(itemdata).length;
    for (let fn in empty_counts) {
        if (empty_counts[fn] == num_skus) {  // All of them are empty
            for (let sku in itemdata) {
                delete itemdata[sku]['options'][fn];
            }
        }
    }
    return itemdata;
}

/**
 * From itemdata, parse out headers (the fixed row on the left) and return as an object
 * Accommodates the possible options column override
 * @return Object
 */
const getItemHeaders = function(itemdata, columnTranslation = {}) {
    let h = [];
    for (let variant in itemdata) {
        for (let rowname in itemdata[variant].options) {
            h.push(rowname);
        }
    }
    h = h.filter((v,i,a)=>a.indexOf(v)==i); // Unique
    let headers = {};
    if (Object.keys(columnTranslation).length) {
        for (let item in columnTranslation) {
            if (h.includes(item)) {
                headers[item] = columnTranslation[item];
            }
        }
    } else {
        for (let item of h) {
            headers[item] = titleCase(item);
        }
    }
    return headers;
};

/**
 * Product-level options are a collection of product-level metafields that may influence behavior of this
 * specific product page.
 * @returns Object
 */
const getProductOptions = function() {
    return grid_data; // This global variable is created inline in product-form-grid.liquid
};

/**
 * Fixed div is on the left (aka headers)
 * @param rowheaders Object
 * @param options Object
 * @returns {jQuery|*|jQuery.fn.init|HTMLElement}
 */
const getFixedDiv = function(rowheaders, itemdata, options = {})  {

    let fixeddiv = $('<div/>').addClass('grid-fixed');
    let i = 0;
    let show_images = true;
    if (typeof(options['images']) != 'undefined') {
        show_images = !!(options['images']);
    }

    // Always a "Model" row
    i++;
    let modeldiv = $('<div/>').addClass('fixed-row context-row').attr('data-row', i).html('Model');
    let itemcount = Object.keys(itemdata).length;
    $(modeldiv).append(
        $('<span/>').html(itemcount + ' models shown')
            .append(
                $('<span/>').addClass('context-row-mobile').html(itemcount > 2 ? 'Swipe for more >' : '&nbsp;')
            )
    );
    $(fixeddiv).append(modeldiv);

    if (show_images) {
        // This is a placeholder where the data div will have images
        i++;
        let imgrowdiv = $('<div/>').addClass('fixed-row').attr('data-row', i);
        $(fixeddiv).append(imgrowdiv);
    }

    // Always a "Price" row
    i++;
    $(fixeddiv).append(
        $('<div/>').addClass('fixed-row').attr('data-row', i).html('Price')
    );



    // Possibly, a top ATC row
    if (Object.keys(rowheaders).length >= DOUBLE_ATC_AT) {
        i++;
        $(fixeddiv).append(
            $('<div/>').addClass('fixed-row').attr('data-row', i).html('&nbsp;')
        );
    }

    for (let h in rowheaders) { // The dynamic rows
        i++;
        $(fixeddiv).append(
            $('<div/>').addClass('fixed-row').attr('data-row', i).html(rowheaders[h])
        );
    }

    // Always an "action" row (Add to cart / quantities)
    i++;
    $(fixeddiv).append(
        $('<div/>').addClass('fixed-row').attr('data-row', i).html('&nbsp;')
    );

    return fixeddiv;
};

/**
 * Float div is the entirety of the product data (the content on the right that might scroll)
 * @param rowheaders Object
 * @param itemdata Object
 * @param options Object
 * @returns {jQuery|*|jQuery.fn.init|HTMLElement}
 */
const getFloatDiv = function(rowheaders, itemdata, options = {}) {
    let floatdiv = $('<div/>').addClass('grid-float');
    let i = 0;
    let cell;
    let selectedvariant = $('#grid-product-selected').val();

    // Model row (always)
    i++;
    let row = $('<div/>').addClass('float-row').attr('data-row', i);
    for (let variant in itemdata) {
        let item = itemdata[variant];
        cell = $('<div/>').addClass('data-cell data-cell-model').html(item.variant);
        if (variant == selectedvariant) {
            $(cell).addClass('selected');
        }
        $(row).append(cell);
    }
    $(floatdiv).append(row);

    let show_images = true;
    if (typeof(options['images']) != 'undefined') {
        show_images = !!(options['images']);
    }
    if (show_images) { // Images row (configurable)
        i++;
        let row = $('<div/>').addClass('float-row').attr('data-row', i);
        for (let variant in itemdata) {
            let item = itemdata[variant];
            // Image for each variant
            cell = $('<div/>').addClass('data-cell data-cell-img').append($('<img/>').attr('src', item.image).attr('alt', item.image_alt || ''));
            if (variant == selectedvariant) {
                $(cell).addClass('selected');
            }
            $(row).append(cell);
        }
        $(floatdiv).append(row);
    }

    // Price row
    $(floatdiv).append(
        pricesRow(++i, itemdata, selectedvariant)
    );

    if (Object.keys(rowheaders).length >= DOUBLE_ATC_AT) {
        $(floatdiv).append( // Top Add to cart row (no quantity selection)
            atcRow(++i, itemdata, options, false, selectedvariant)
        );
    }

    for (let h in rowheaders) { // Each data row
        i++;
        let row = $('<div/>').addClass('float-row').attr('data-row', i);
        for (let variant in itemdata) {
            let item_options = itemdata[variant].options || [];
            cell = $('<div/>').addClass('data-cell').html(item_options[h] || '&nbsp;');
            if (variant == selectedvariant) {
                $(cell).addClass('selected');
            }
            $(row).append(cell);
        }
        $(floatdiv).append(row);
    }

    $(floatdiv).append( // Add to cart row
        atcRow(++i, itemdata, options, true, selectedvariant)
    );

    return floatdiv;
};

/**
 * For clicking on OOS buttons; this is what it takes to trigger the istock notification.
 * #explosive-oos is a hidden select box containing id->name values of oos variants
 */
let oosClick = function(variantID) {
    let oosSelect = $('#explosive-oos');
    oosSelect.val(variantID);
    oosSelect.trigger('change');
    alertModal('iStock');
};



/**
 * The "quantity" field, driven by how many are actually available
 * If there are none available it's a disabled text box;
 * If more than 10 are available it's a dropdown with a hidden text box for values over 10
 * Otherwise it's a dropdown limited to the number we have.
 * Edge case note: If you already have some of our quantity in your cart the add still might fail despite the limits
 * @param inventory Availability for this variant
 * @returns {jQuery|HTMLElement|*}
 */


const quantity_field = function (inventory) {
    let inv = parseInt(inventory);
    let qtyfield = $('<span />').addClass('pg-qty-field');

    if (inv <= 0) {  // Out of stock
        return $(qtyfield).append(
            $('<input type="text" />')
                .addClass('pg-oos')
                .attr('disabled', 'disabled')
                .attr('aria-label', 'Out of Stock')
                .val('Out of Stock')
        );
    }

    let hidden_txtbox = false;
    if (inv > 12) {
        inv = 12;
        hidden_txtbox = true;
    }

    let dd = $('<select name="quantity" />').addClass('pg-qty').addClass('qty-active').attr('aria-label', 'Quantity');
    for (let i = 1; i <= inv; i++) {
        $(dd).append($('<option />').attr('value', i).text(i));
    }

    if (hidden_txtbox) {
        $(dd).append($('<option />').attr('value', '13').text('More...'));
        let tenplus_input = $('<input type="text" value="13">').addClass('pg-tenplus');
        return $(qtyfield).append(dd).append(tenplus_input);
    } else {
        return $(qtyfield).append(dd);
    }
};

const pricesRow = function(idx, itemdata, selectedvariant) {

    let row = $('<div/>').addClass('float-row').attr('data-row', idx);
    for (let variant in itemdata) {
        let selling = (parseInt(itemdata[variant]['price']) / 100).toFixed(2);
        let retail = (parseInt(itemdata[variant]['retail_price']) / 100).toFixed(2);
        let diff = (retail - selling).toFixed(2);
        let cell = $('<div/>').addClass('data-cell');
        // Selling price
        $(cell).append(
            $('<span/>').addClass('selling-price').html('$' + selling)
        );
        if ((diff) > 1) {
            $(cell).append(
                $('<span/>').addClass('retail-price').html('$' + retail)
            );
            $(cell).append(
                $('<span/>').addClass('price-save').html('Save $' + diff )
            );
        }
        if (variant == selectedvariant) {
            $(cell).addClass('selected');
        }
        $(row).append(cell);
    }
    return row;
};

const atcRow = function (idx, itemdata, options = {}, includeQty = true, selectedvariant) {
    let row = $('<div/>').addClass('float-row').attr('data-row', idx);

    for (let variant in itemdata) {
        let item = itemdata[variant];
        let cell = $('<div/>').addClass('data-cell data-cell-atc');

        let continueSelling = item['continue_selling'] === 'continue';
        let inventory = parseInt(item['inventory']);
        let available = inventory > 0;

        console.log('continueSelling:', continueSelling, 'Available:', available);

        if (continueSelling) {
            // If continueSelling == 'continue', allow adding to cart normally
            cell.append(
                $('<span/>').addClass('pg-availability').text(window.DTAvailability.resolveById(item['id']))
            );
            cell.attr('id', 'atc-' + item['id']).append(quantity_field(1, 10)); // Dropdown 1-10

            let atcbutton = $('<input type="submit" value="Add" />')
                .addClass('pg-atc-button')
                .attr('data-id', item['id']);

            cell.append(
                $('<div/>').attr('id', 'submit-' + item['id'])
                    .append(atcbutton)
                    .append($('<div/>').addClass('msg'))
            );
        } else {
            // Normal logic (disable button if out of stock)
            cell.append(
                $('<span/>').addClass('pg-availability').text(
                    available ? window.DTAvailability.resolveById(item['id']) : ' '
                )
            );
    
           if (includeQty) {
                cell.attr('id', 'atc-' + item['id']).append(quantity_field(item['inventory']));
            }

            let atcbutton = $('<input type="submit" value="Add" />')
                .addClass('pg-atc-button')
                .attr('data-id', item['id']);

            if (!available) {
                $(atcbutton).addClass('disabled').val('Notify Me'); // Disable if out of stock
            }

            cell.append(
                $('<div/>').attr('id', 'submit-' + item['id'])
                    .append(atcbutton)
                    .append($('<div/>').addClass('msg'))
            );
        }

        if (variant == selectedvariant) {
            $(cell).addClass('selected');
        }

        $(row).append(cell);
    }

    return row;
};

/**
 * After the grid is drawn, adjust the height of any row labels ("fixed")
 * to match the height of that row's values ("float")
 * Can go in either direction
 */
const adjustRowHeights = function() {
    $('.fixed-row').each(function() {
        let rowid = $(this).data('row');
        if (rowid) {
            let matchingRow = $(document).find('.float-row[data-row=' + rowid + ']');
            let labelHeight = parseInt($(this).outerHeight());
            let rowHeight = parseInt($(matchingRow).outerHeight());
            if (rowHeight && labelHeight) {
                if (rowHeight > labelHeight) {
                    $(this).css('height', rowHeight);
                } else if (labelHeight > rowHeight) {
                    $(matchingRow).css('height', labelHeight );
                }
            }
        }
    });
};

// A11y (WCAG 4.1.3 Status Messages): the grid's .msg confirmation is not a live region, so
// add-to-cart success/errors on the grid experience were not announced to screen readers.
// Mirror the message text into a shared, visually-hidden aria-live region (shared with
// explosive.js via the #sr-atc-announcer id). Clear-then-set re-announces repeated messages.
const srAnnounce = function(message) {
    if (!message) return;
    let text = $('<div>').html(message).text().trim();
    if (!text) return;
    let el = document.getElementById('sr-atc-announcer');
    if (!el) {
        el = document.createElement('div');
        el.id = 'sr-atc-announcer';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
        el.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
        document.body.appendChild(el);
    }
    el.textContent = '';
    window.setTimeout(function() { el.textContent = text; }, 60);
};

const toggleSubmitButton = function(btn, message, classname) {
    let msgtarget = $(btn).parent().find('.msg');
    $(btn).hide();
    $(msgtarget).addClass(classname).html(message).show();
    srAnnounce(message); // WCAG 4.1.3 — announce to screen readers
    setTimeout(function() {
        $(msgtarget).hide();
        $(btn).show();
    }, 2000);
};

const submitForm = function(btn) {
    let targetid = $(btn).data('id');
    let atcelem = $('#atc-' + targetid);
    let qty = $(atcelem).find('.qty-active').val();
    let postData = { quantity: qty, id: targetid};

    if (!parseInt(qty)) {
        $(atcelem).find('.qty-active').addClass('please-note');
        return;
    }

    $.post('/cart/add.js', postData, null, 'json')
        .done(function(e) {
            toggleSubmitButton(btn, 'Added ' + qty + ' to <a href="/cart">cart</a>', 'ok');
            addToCartHeader(qty);
        })
        .fail(function(e) {
            toggleSubmitButton(btn,'Cannot add more to cart', 'error');
        });
};

/**
 * The below fires on page load, assuming a #grid-product-container element exists.
 */
$(function () {

    if ($('#grid-product-container').length) {

        let productoptions = getProductOptions();
        let itemdata =  parseItemData();
        let rowheaders = getItemHeaders(itemdata, JSON.parse(productoptions['columns']) || {});
        let grid = $('<div/>').addClass('grid-product-grid');

        // Draw the grid
        $(grid).append(getFixedDiv(rowheaders, itemdata, productoptions));
        $(grid).append(getFloatDiv(rowheaders, itemdata, productoptions));
        $('#grid-product-grid').append(grid);
        adjustRowHeights();
        if (typeof bind_klaviyo == 'function') {
            // Global defined in static-product.liquid
            bind_klaviyo(document.querySelectorAll('.pg-atc-button:not(.disabled)'));
        }

        /**
         * On window resize, redraw field heights
         */
        $(window).resize(function() { adjustRowHeights(); });

        /**
         * Clicked add to cart submit button
         */
        $('.pg-atc-button').on('click', function(e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) {
                oosClick($(this).data('id'));
                return false;
            }
            else{
              submitForm(this);
            }
        });

        /**
         * If large qty is selected, swap out the dropdown for an open-input textbox
         */
        $('.pg-qty').on('change', function() {
            if ($(this).val() == '13') {
                $(this).removeClass('qty-active').hide();
                $(this).parent().find('input[type=text]').addClass('qty-active').show().focus();
            }
        });
    }
  
});